import { useEffect } from 'react';
import { FormikProps, useFormik } from 'formik';
import * as Yup from 'yup';

import { useZoneFeedbackMutation } from 'store/apis';

interface UseZoneFeedbackFormManagerProps {
  zoneId: number;
  next?: (data?: any) => void;
}

export const useZoneFeedbackFormManager = ({ zoneId, next = () => {} }: UseZoneFeedbackFormManagerProps) => {
  const [mutate, { isLoading, isSuccess, isError, ...rest }] = useZoneFeedbackMutation();

  const initialValues = {
    name: '',
    email: '',
    phone: '',
    services: [] as string[],
    message: '',
  };

  const validationSchema = Yup.object({
    name: Yup.string().nullable(),
    email: Yup.string().nullable(),
    phone: Yup.string().nullable(),
    services: Yup.array().of(Yup.string()),
    message: Yup.string().nullable().required('This value is required.'),
  });

  const formManager = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (zoneFeedback, { resetForm }) => {
      resetForm({});

      mutate({
        zoneId,
        ...zoneFeedback,
      });
    },
  });

  useEffect(() => {
    if (!isLoading && isSuccess && !isError) {
      const { data } = rest;

      next(data);
    }
  }, [isLoading, isSuccess, isError]);

  return [
    {
      formManager,
      loading: isLoading,
    },
  ] as [
    {
      formManager: FormikProps<typeof initialValues>;
      loading: boolean;
    },
  ];
};
